<template>
  <Popup
    v-if="isVisible"
    :name="popupName"
    :is-modal="true"
  >
    <template v-slot:content>
      <p class="page-home__message">
        {{ t('global.meterNotReachableMessage') }}
      </p>
    </template>
  </Popup>

</template>

<script setup>
import Popup from '@/components/popups/Popup.vue'
import { useSpecificPopup } from '@/composables/useSpecificPopup.ts'
import { useStrings } from '@/composables/useStrings.ts'

const popupName = 'meterNotReachable'
const { t } = useStrings()
const { isVisible } = useSpecificPopup(popupName)
</script>